import { render, staticRenderFns } from "./OrderHome.vue?vue&type=template&id=b9594d34&"
import script from "./OrderHome.vue?vue&type=script&lang=ts&"
export * from "./OrderHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports